import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidatorsService } from '../../../../services/validators/validators.service';
import { RedirectFbService } from '../../../../services/redirect-fb/redirect-fb.service';
import { Router } from '@angular/router';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { AuthPageManageService } from 'src/app/services/manage/page-manage/auth-page-manage.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})

export class ResetPasswordComponent implements OnInit {

  newPassForm: FormGroup | any;
  error$: string | any;

  loaderResetPass: boolean = false;

  constructor(
    private fbServ: RedirectFbService,
    private formBuilder: FormBuilder,
    private vs: ValidatorsService,
    private router: Router,
    private tools: ToolsService,
    public authManPag: AuthPageManageService,
    public translate: TranslateService
  ) { }

  ngOnInit() {

   
  
    this.createNewPassForm();
    this.fbServ.getError.subscribe(data => {
      this.error$ = data;
    })
  }

  createNewPassForm() {
    this.newPassForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
      confPassword: ['', [Validators.required]]
    }, {
      validator: this.vs.MatchPassword
    });
  }

  isFieldrequired(field: string) {
    let thisField = this.newPassForm.controls[field];
    if (thisField.errors) {
      if (thisField.errors.required) {
        return true;
      }
    }
    return;
  }

  submitNewPass() {
    const that = this;
    const formVal = that.newPassForm.value;
    that.error$ = "";

    if (that.newPassForm.valid) {


      that.loaderResetPass = true;
      that.fbServ.resetPassword(formVal.password).then(() => {
        that.loaderResetPass = false;
        
        that.tools.setStatusMessage( this.translate.instant('resetPassComp.passModi'));
      
        that.authManPag.moveToLogin();

        that.router.navigate(["/auth/home"]);
      })

    }
  }

  goAuth() {
    this.router.navigate(["/auth/home"]);
  }

}
